import { ORIGIN, post, request } from "~/core/api";
export type ContentKind = "text" | "article" | "gallery" | "video";
export type Part =
	| { type: "text"; text: string }
	| { type: "image"; file_id: string; alt: string }
	| { type: "scene"; text: string; file_id: string | null; seconds: number };
export interface Asset {
	file_id: string;
	role: string;
	alt: string;
}
export interface ContentDocument {
	body: string;
	blocks: Part[];
	media: Asset[];
	sources: string[];
}
export interface StudioFile {
	id: string;
	agent_file_id?: string;
	name: string;
	content_type: string;
	width: number | null;
	height: number | null;
	duration_ms: number | null;
	size: number;
}
export interface Variant {
	revision: number;
	task_id: string | null;
	id: string;
	platform: string;
	source_revision: number;
	issues: string[];
	document: { target_url?: string; fields: Record<string, string>; media: Asset[]; blocks: Part[] };
	approved_at: string | null;
}
export interface ContentItem {
	renders?: {
		id: string;
		status: string;
		error: string | null;
		output: { attached: boolean; files?: Asset[] } | null;
	}[];
	id: string;
	title: string;
	kind: ContentKind;
	locale: "en" | "zh";
	revision: number;
	document: ContentDocument;
	files: StudioFile[];
	variants: Variant[];
	updated_at: string;
}
export const studioKey = (brand: string) => ["studio", brand];
export const listContent = (brand: string) =>
	request<{ items: ContentItem[]; files: StudioFile[] }>(`/entities/${brand}/studio`);
export const readContent = (brand: string, id: string) => request<ContentItem>(`/entities/${brand}/studio/${id}`);
export async function studioCommand<T>(brand: string, capability: string, input: unknown) {
	const op = await post<{ output: T }>(`/entities/${brand}/studio`, {
		capability,
		input,
		request_id: crypto.randomUUID(),
	});
	return op.output;
}
export const fileUrl = (id: string) => `${ORIGIN}/api/v1/agent/files/serve/${encodeURIComponent(id)}`;
export const emptyDocument = (): ContentDocument => ({ body: "", blocks: [], media: [], sources: [] });

export const studioOptions = (brand: string) =>
	request<{
		models: {
			id: string;
			name: string;
			modality: string;
			credits_per_1000_input: number;
			credits_per_1000_output: number;
		}[];
	}>(`/entities/${brand}/studio/options`);
